import { getActions, getReducers, getTypes } from '../initializers';
import { actions as getUserActions, types as getUserTypes } from './get';

// updating user state
const identifier = 'USER_UPDATE_SKIN';

export const getUserUpdateSkinState = (state) => state.user?.userUpdateSkin;

const fetchOptions = (params) => {
  const { id, skinId, skinPrice } = params;
  return {
    method: 'PUT',
    body: JSON.stringify({
      id,
      skinId,
      skinPrice,
    }),
  };
};

export const types = getTypes(identifier);
export const actions = getActions(
  identifier,
  (params) => `users/addSkin/${params.id}`,
  (params) => fetchOptions(params),
  undefined,
  (payload) => getUserActions.update(getUserTypes, payload)
);
const reducer = getReducers(identifier);

export default reducer;
